import { render, staticRenderFns } from "./studio-entrance.vue?vue&type=template&id=c603a21c&scoped=true&"
import script from "./studio-entrance.vue?vue&type=script&lang=js&"
export * from "./studio-entrance.vue?vue&type=script&lang=js&"
import style0 from "./studio-entrance.vue?vue&type=style&index=0&id=c603a21c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c603a21c",
  null
  
)

export default component.exports